// Source of truth: must match backend values
export const EMPLOYEE_ROLES = Object.freeze([
    "Manager",
    "Senior",
    "Staff",
    "AdministrativeAssistant",
]);

// UI labels
export const ROLE_LABELS = Object.freeze({
    Manager: "Manager",
    Senior: "Senior",
    Staff: "Staff",
    AdministrativeAssistant: "Administrative Assistant",
});

// Optional: roles that can be assigned to jobs (frontend filter)
export const ASSIGNABLE_ROLES = Object.freeze([
    "Senior",
    "Staff",
    "AdministrativeAssistant",
]);

// Robust pretty label resolver (handles spaces/casing quirks safely)
export const getRoleLabel = (value) => {
    if (value == null) return "";
    const raw = String(value);
    if (ROLE_LABELS[raw]) return ROLE_LABELS[raw];

    const trimmed = raw.trim();
    if (ROLE_LABELS[trimmed]) return ROLE_LABELS[trimmed];

    // If backend ever sends "Administrative Assistant" with a space:
    const noSpaces = trimmed.replace(/\s+/g, "");
    if (ROLE_LABELS[noSpaces]) return ROLE_LABELS[noSpaces];

    // Fallback: show raw value
    return raw;
};
